import { Flex, Modal, Skeleton } from "antd"
import { defaultInvoice } from "../../../domain/invoicing/invoice"
import VSpace from "../../common/VSpace"
import PaymentMethodsCard from "./PaymentMethodsCard"
import { ReactNode, useEffect, useState } from "react"
import { SendInvoiceRequest } from "../../../domain/invoicing/invoicingApi"
import { initializeSendInvoiceRequest } from "./sendInvoiceModel"
import PaymentMethodOnFileCard from "./PaymentMethodOnFileCard"
import DueDateCard from "./DueDateCard"
import { InvoicingSettings } from "../../../domain/invoicing/settings/invoicingSettings"
import { getDefaultDueDate } from "../Creation/createInvoiceModel"
import { centsToDollarsDisplay } from "../../displayFormatters"
import { useInvoiceDetailsQuery, useSendInvoiceMutation } from "../../../domain/invoicing/invoicingQueries"

type Props = {
  isOpen: boolean
  onClose: () => void
  invoiceId: string
  emailAddresses: string[]
  invoicingSettings: InvoicingSettings
  notice?: ReactNode
}

const SendInvoiceModal = ({ isOpen, onClose, invoiceId, emailAddresses, invoicingSettings, notice }: Props) => {
  const detailsQuery = useInvoiceDetailsQuery(invoiceId)
  const [request, setRequest] = useState<SendInvoiceRequest>(initializeSendInvoiceRequest(defaultInvoice(), emailAddresses))
  const defaultDueDate = getDefaultDueDate(invoicingSettings)
  const sendInvoiceMutation = useSendInvoiceMutation()

  const invoice = detailsQuery.data?.invoice

  useEffect(() => {
    if (isOpen && invoice) {
      setRequest(initializeSendInvoiceRequest(invoice, emailAddresses))
    }
  }, [invoice, emailAddresses, isOpen])

  const isLoading = detailsQuery.isLoading || !invoice

  return <Modal
    open={isOpen}
    onCancel={onClose}
    onOk={() => sendInvoiceMutation.mutate(request, {
      onSuccess: () => onClose()
    })}
    title="Send Invoice"
    okText="Send"
    okButtonProps={{ loading: sendInvoiceMutation.isLoading, disabled: sendInvoiceMutation.isLoading }}
    width={800}
  >
    {isLoading && <Skeleton active />}
    {!isLoading && <VSpace>
      {notice}
      <PaymentMethodsCard
        options={request.invoiceUpdates}
        onUpdate={(invoiceUpdates) => setRequest({ ...request, invoiceUpdates })}
      />
      <PaymentMethodOnFileCard
        options={request.invoiceUpdates}
        onUpdate={(invoiceUpdates) => setRequest({ ...request, invoiceUpdates })}
      />
      <DueDateCard
        options={request.invoiceUpdates}
        onUpdate={(invoiceUpdates) => setRequest({ ...request, invoiceUpdates })}
        defaultDueDate={defaultDueDate}
      />
      <div style={{borderTop: '1px solid #00000026', borderBottom: '1px solid #00000026', padding: '12px 0', fontSize: '16px'}}>
        <Flex justify="space-between" gap={8}>
          <strong>Invoice Total</strong>
          <strong>{centsToDollarsDisplay(invoice.total)}</strong>
        </Flex>
      </div>
    </VSpace>}
  </Modal>
}

export default SendInvoiceModal
